

export default {
    props: ['instances'],

    data() {
        return {
            ref: null,
            showListCampus: false,
            openNavBar: false,
        };
    },
    methods: {
        // scrollToCampus() {
        //     const element = document.getElementById("campus");
        //     element.scrollIntoView({ behavior: 'smooth' });
        // },
        // scrollToDiplomes() {
        //     const element = document.getElementById("diplomes");
        //     element.scrollIntoView({ behavior: 'smooth' });
        // },
        openCampusesList(event) {
            this.showListCampus = !this.showListCampus;
            this.showListDiploma = false;
        },
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.showListDiploma = false
                this.showListCampus = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.close)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.close)
    }
}
